import { FormItem } from '@vindr/ui';

import { Button, Col, Form, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';

const ChangePassword = ({
  isLoading = false,
  onSubmit,
  okText = 'Save',
  closable = true,
  cancelText = 'Cancel',
  onCancel = () => {},
}) => {
  const { t } = useTranslation('Vindoc');

  const [form] = Form.useForm();
  const password = Form.useWatch('password', form);

  const actionSave = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal
      open={true}
      maskClosable={false}
      closable={closable}
      onCancel={onCancel}
      centered
      forceRender
      footer={null}
      title={t('Change Password')}
      // width="60%"
      confirmLoading={isLoading}
    >
      <Form form={form} onFinish={actionSave} layout="vertical" name="edit-account">
        <Row gutter={32}>
          <Col xs={24}>
            <FormItem.Password required={true} />
            <FormItem.PasswordConfirm required={true} password={password} />
          </Col>
        </Row>
      </Form>
      <div className="footer mt-3 flex justify-end">
        {closable && (
          <Button className="mr-2" onClick={onCancel}>
            {t(cancelText)}
          </Button>
        )}
        <Button type="primary" onClick={actionSave}>
          {t(okText)}
        </Button>
      </div>
    </Modal>
  );
};

export default ChangePassword;
